import { render, staticRenderFns } from "./Crews.vue?vue&type=template&id=66dd7510&scoped=true"
import script from "./Crews.vue?vue&type=script&setup=true&lang=ts"
export * from "./Crews.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Crews.vue?vue&type=style&index=0&id=66dd7510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd7510",
  null
  
)

export default component.exports